var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 88,
    height: 88,
    rx: 17,
    stroke: "#F5FBFC",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.3301 70V65.5882H42.7941V55.5088C40.298 55.0074 38.0922 53.9574 36.1765 52.3588C34.2608 50.7598 32.8995 48.7669 32.0926 46.3801C28.699 45.9767 25.8353 44.5363 23.5015 42.0588C21.1672 39.5814 20 36.6402 20 33.2353V30.2941C20 29.0912 20.4346 28.0551 21.3037 27.186C22.1728 26.3169 23.2088 25.8824 24.4118 25.8824H31.2559V20H58.7441V25.8824H65.5882C66.7912 25.8824 67.8272 26.3169 68.6963 27.186C69.5654 28.0551 70 29.0912 70 30.2941V33.2353C70 36.6402 68.8328 39.5814 66.4985 42.0588C64.1647 44.5363 61.301 45.9767 57.9074 46.3801C57.1005 48.7669 55.7392 50.7598 53.8235 52.3588C51.9078 53.9574 49.702 55.0074 47.2059 55.5088V65.5882H57.6699V70H32.3301ZM31.2559 41.6404V30.2941H24.4118V33.2353C24.4118 35.2868 25.0547 37.0882 26.3404 38.6397C27.6262 40.1912 29.2647 41.1914 31.2559 41.6404ZM45 51.2787C47.5828 51.2787 49.7745 50.3782 51.575 48.5772C53.3755 46.7767 54.2757 44.585 54.2757 42.0022V24.4118H35.7243V42.0022C35.7243 44.585 36.6245 46.7767 38.425 48.5772C40.2255 50.3782 42.4172 51.2787 45 51.2787ZM58.7441 41.6404C60.7353 41.1914 62.3738 40.1912 63.6596 38.6397C64.9453 37.0882 65.5882 35.2868 65.5882 33.2353V30.2941H58.7441V41.6404Z",
    fill: "#F5FBFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.46ef0c32ac28b6ca33c636994d805793.svg";
export { ForwardRef as ReactComponent };